import React from "react";
import { Link, useLocation } from "react-router-dom";
import { CalendarRange, LogOut, Moon, Sun, LayoutGrid, BarChart3, Users, SlidersHorizontal } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { useTheme } from "@/context/ThemeContext";

export default function Header() {
  const { user, logout } = useAuth();
  const { theme, toggle } = useTheme();
  const { pathname } = useLocation();

  const nav = [
    { to: "/", label: "Painel", slug: "painel", icon: LayoutGrid },
    { to: "/graficos", label: "Gráficos", slug: "graficos", icon: BarChart3 },
    { to: "/definicoes-kpi", label: "KPIs", slug: "definicoes-kpi", icon: SlidersHorizontal },
    ...(user?.role === "superadmin" ? [
      { to: "/utilizadores", label: "Utilizadores", slug: "utilizadores", icon: Users },
    ] : []),
  ];

  return (
    <header className="sticky top-0 z-40 backdrop-blur-md bg-background/80 border-b border-border">
      <div className="max-w-[1600px] mx-auto px-4 sm:px-6 lg:px-8 py-3.5 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 sm:gap-6">
          <div className="flex items-center gap-3">
            <div className="h-9 w-9 rounded-lg bg-primary flex items-center justify-center">
              <CalendarRange className="h-5 w-5 text-primary-foreground" />
            </div>
            <div className="hidden sm:block">
              <span className="font-display text-base font-extrabold tracking-tight block leading-none">Mundideias CRM</span>
              <span className="text-xs text-muted-foreground">Gestão de Processos</span>
            </div>
          </div>
          <nav className="flex items-center gap-1">
            {nav.map((n) => {
              const Icon = n.icon;
              const active = pathname === n.to;
              return (
                <Link key={n.to} to={n.to} data-testid={`nav-${n.slug}`}
                  className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-semibold transition-colors ${
                    active ? "bg-primary/10 text-primary" : "text-muted-foreground hover:bg-muted hover:text-foreground"}`}>
                  <Icon className="h-4 w-4" />
                  <span className="hidden sm:inline">{n.label}</span>
                </Link>
              );
            })}
          </nav>
        </div>
        <div className="flex items-center gap-2">
          <button onClick={toggle} data-testid="theme-toggle"
            className="p-2 rounded-lg hover:bg-muted transition-colors">
            {theme === "dark" ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
          </button>
          <div className="hidden md:flex flex-col items-end mr-1">
            <span className="text-sm font-semibold leading-none">{user?.name}</span>
            <span className="text-xs text-muted-foreground">{user?.email}</span>
          </div>
          <Button variant="outline" size="sm" onClick={logout} data-testid="logout-button" className="gap-2">
            <LogOut className="h-4 w-4" /> <span className="hidden sm:inline">Sair</span>
          </Button>
        </div>
      </div>
    </header>
  );
}
